import { render, staticRenderFns } from "./CreateRecepcionistAdmin.vue?vue&type=template&id=2902c38c&scoped=true&"
import script from "./CreateRecepcionistAdmin.vue?vue&type=script&lang=ts&"
export * from "./CreateRecepcionistAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRecepcionistAdmin.vue?vue&type=style&index=0&id=2902c38c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2902c38c",
  null
  
)

export default component.exports